import React, { useState } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import { ReactComponent as EyeCross } from "../../assets/eyeCross.svg";
import { ReactComponent as Eye } from "../../assets/fi-rr-eye.svg";
import CustomButton from "../../components/CustomButton";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import base_url from "../../api/bootapi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { logout } from "../../components/Reducers/userSlice";

const CreateNewPassword = () => {
  // const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [changeSuccessfull, setChangeSuccessfull] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { token, email } = useParams();

  console.log("Token:", token);
  console.log("Email:", email);

  const isFormValid = email && password && confirmPassword;

  const validatePassword = (password) => {
    const minLength = /.{6,}/;

    if (!minLength.test(password)) {
      return "Password must be at least 6 characters long.";
    }

    return null;
  };

  const handle403error = (err) => {
    if (err) {
      if (err.response) {
        if (
          Number(err?.response?.status) === 403 ||
          Number(err?.response?.status) === 401
        ) {
          setTimeout(() => {
            console.log("Unauthorized or forbidden. Logging out.");
            dispatch(logout());
            // localStorage.clear();
            localStorage.setItem("from_403_status", "call_toast");
            navigate("/login");
            // toast.warn("Session Expired");
            toast.success("Token Expired");
          }, 1000);
        }
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post(
        `${base_url.api1}/users/forgot_password_change`,
        {
          email,
          password,
        },
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      );
      console.log("RESPONSE============================> ", response.data);
      if (response?.data?.status_code === 400) {
        setError(response?.data?.message);
        return;
      }
      setChangeSuccessfull(true);
      toast.success("Password changed Successfully");
    } catch (err) {
      console.log("Error =================================> ", err);
      setChangeSuccessfull(false);

      setError("Error: Unable to create new password");

      // toast.error("Error: Unable to create new password");
      console.error("Error:", err.response.data.detail);
      handle403error(err);
    }
  };

  return (
    <div>
      <Nav />

      <div className="register">
        <ToastContainer />
        {!changeSuccessfull ? (
          <div className="register-container">
            <div>
              <h3>Create new password</h3>
            </div>

            <form className="input-container" onSubmit={(e) => handleSubmit(e)}>
              <div style={{ marginTop: "20px" }}>
                <label>
                  New password <span style={{ color: "#D04244" }}>*</span>
                </label>
                <div
                  style={{ border: error ? "1px solid #D04244" : "none" }}
                  className="input-box"
                >
                  <input
                    className="save-progress-input"
                    placeholder={"Enter your password"}
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {showPassword ? <EyeCross /> : <Eye />}
                  </button>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>
                  Confirm password <span style={{ color: "#D04244" }}>*</span>
                </label>
                <div
                  style={{ border: error ? "1px solid #D04244" : "none" }}
                  className="input-box"
                >
                  <input
                    className="save-progress-input"
                    placeholder={"Confirm your password"}
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {showConfirmPassword ? <EyeCross /> : <Eye />}
                  </button>
                </div>
              </div>

              <div style={{ marginTop: "5px", marginBottom: "0" }}>
                {error ? (
                  <p style={{ textAlign: "center", color: "#D04244" }}>
                    {error}
                  </p>
                ) : (
                  <p></p>
                )}
              </div>

              <CustomButton
                style={{
                  width: "100%",
                  marginTop: "30px",
                  backgroundColor: !isFormValid ? "#ccc" : "#314064",
                  cursor: !isFormValid ? "not-allowed" : "pointer",
                }}
                btnText="RESET PASSWORD"
                type="submit"
                disabled={!isFormValid}
              />
            </form>
          </div>
        ) : (
          <div className="register-container">
            <div>
              <h3>Success!</h3>
              <p style={{ marginTop: "20px" }}>
                You’ve successfully updated the password! Now you can log in to
                your account.
              </p>
            </div>

            <CustomButton
              style={{ width: "100%", marginTop: "30px" }}
              btnText="BACK TO LOGIN"
              onClick={() => navigate("/login")}
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default CreateNewPassword;
